module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/editor-1-f09f18ee2ef339e034a24e75905dd18e.webp";